import { ModBox, RadioButtonGroup, SpacerNew } from '@jfs/ui-new'
import { Button } from '../AdminButton'
import React from 'react'
import { styles } from './styles'
interface RadioButtonDropdownInterface {
  data: any
  isExportType: boolean
  fileFormatType: string
  updateFileFormat: (fileName: string) => void
  handleDownload: () => void
  buttonLabel: string
  downloadBtntestID?: string
}

export const RadioButtonDropdown = ({
  data,
  isExportType,
  fileFormatType,
  updateFileFormat,
  handleDownload,
  buttonLabel,
  downloadBtntestID = '',
}: RadioButtonDropdownInterface) => {
  return (
    <ModBox show={isExportType} {...styles.exportBox}>
      <RadioButtonGroup
        data={data.map((item: any) => {
          return item.title as string
        })}
        value={fileFormatType}
        size={14}
        textSize={14}
        seperatorWidth={1}
        minItemHeight={43}
        textPadding={8}
        textColor="BLACK_21"
        onChange={(selectedRadioButtonText): void => updateFileFormat(selectedRadioButtonText)}
        hide={false}
        testID={'radioButtonGroup'}
      />
      <SpacerNew size={10} direction="vertical" />
      <Button
        testID={downloadBtntestID}
        hide={false}
        onPress={handleDownload}
        color={'PRIMARY'}
        textColor={'WHITE'}
        type={'SecondaryWithBg'}
        title={buttonLabel}
      />
    </ModBox>
  )
}
